<eo-search-panel
  [formGroup]="eoForm.form"
  [menuActions]="menuActions"
  [viewModeVisible]="viewModeVisible"
  [actionMenuVisible]="actionMenuVisible"
  [instructionsVisible]="instructionsVisible"
  [instructionsMenuItem]="instructionsMenuItem"
  (viewModeChange)="onViewModeSelect($event)"
  [isCollapsed]="collapsed"
>
  <ng-container header>
    <ng-content select="[header]" />
  </ng-container>

  <ng-container actions>
    <ng-content select="[actions]" />
  </ng-container>

  <div class="flex flex-column container p-3">
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      [submitButtonVisible]="false"
      [submitButtonLoading]="isSubmitLoading()"
      [submitButtonLabel]="submitBtnLabel"
      [customFormControls]="customFormControls"
      (formSubmit)="onSubmit($event)"
      (formChange)="onFormChange($event)"
    />
    <div
      class="p-fluid flex flex-column md:flex-wrap md:flex-row md:justify-content-end gap-2 w-full mt-3"
    >
      <p-button
        size="small"
        label="Καθαρισμός"
        severity="warning"
        icon="pi pi-replay"
        (onClick)="onClear()"
        [disabled]="isLoading()"
        *ngIf="getShowClearButton()"
      />

      <p-button
        size="small"
        label="Αναζήτηση"
        icon="pi pi-search"
        [disabled]="!eoForm.form.valid || isLoading()"
        [loading]="isLoading()"
        (onClick)="onSubmit()"
      />
    </div>
  </div>
</eo-search-panel>

<div
  *ngIf="isNoDataLabelVisible()"
  class="flex justify-content-center m-3 font-semibold"
>
  Δεν βρέθηκαν δεδομένα με τα συγκεκριμένα κριτήρια
</div>

<eo-table
  #eoTableResults
  *ngIf="isTableVisible()"
  [currentPage]="getPage()"
  [rows]="getPagesize()"
  [totalRecords]="getTotalCount()"
  [config]="tableConfig"
  [loading]="isLoading() || loading"
/>

<eo-paginator
  *ngIf="isPaginatorVisible()"
  [currentPage]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  (pageChange)="onPageChange($event)"
/>

<p-confirmDialog key="searchPageMessage" />
